// extracted by mini-css-extract-plugin
module.exports = {"container":"error-message_container__2lK_H","text":"error-message_text__4LK2j"};